import React,{useState,useEffect} from 'react';
import WhatsAppButton from './whatsapp';
import Footer from './Footer';
import Header from './Header';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import { uploadUrl } from './uploadUrl';
import { useNavigate,Link } from 'react-router-dom';
import AuthModal from './AuthModal';
import Chat from './chat';
import {Helmet} from 'react-helmet';
import Marquee from './marquee';


const Detail=()=>{

    const {id}=useParams();
    const [detail,setdetail]=useState([]);
    const [affordable,setaffordable]=useState([]);
     const [news,setnews]=useState([]);
     const navigate=useNavigate();

    const [cat,setcatsubcat]=useState([]);
     const [cats,setcatsubcats]=useState([]);
     const [showModal,setshowModal]=useState(false);
    

     const [selectedlove,setselectedlove]=useState([]);

    useEffect(() => {
  const fetchDetail = async () => {
    try {
      const res = await axios.get(
        `https://api.squareandangle.pranatigroup.in/api/admin/catsubcatid/${id}`
      );
    
      setdetail(res.data.result);
    } catch (error) {
      console.log("Detail API error:", error.response?.data || error.message);
    }
  };

 

  const fetchnews=async()=>{
    try {
      const res = await axios.get(
        `https://api.squareandangle.pranatigroup.in/api/admin/news`
      );
      setnews(res.data);
    } catch (error) {
      console.log("Affordable API error:", error.response?.data || error.message);
    }
  }
   const fetcatsubcat=async()=>{
      try{
     const res= await axios.get(`https://api.squareandangle.pranatigroup.in/api/admin/designideasall`);
    
     setcatsubcat(res.data.category);
    setcatsubcats(res.data.subcategory);
      }catch(error){
      console.error(error);
      }
    }
   fetcatsubcat();

  fetchnews();
  fetchDetail();
}, [id]);


   const handlelove=async(id)=>{
   
    const userId = localStorage.getItem('userId') || (JSON.parse(localStorage.getItem('user') || 'null')?.id);

    if (!userId) {
      setshowModal(true);
      return;
    }
      try{

       const res = await axios.post(
            `https://api.squareandangle.pranatigroup.in/api/admin/lovestate/${id}`,
            {userId:userId},
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
           );

           if(res.data.loved){
            setselectedlove((prev)=>[
                ...prev,id
            ])
           }else{
             setselectedlove((prev)=>
                prev.filter((item)=>item !==id)
             )
        
            
           }
    }catch(e){
       console.log(e);
       alert(e?.response?.data?.message || 'Love action failed');
   }
   }

return(
    <>
<AuthModal showModal={showModal} setshowModal={setshowModal} />
<Header />   
<Marquee/>

 <Helmet>
        <title>Pranati Interior - Kolkata best Interior</title>
        <meta name="description" content="Welcome to Kolkata best interior" />

        <link rel="canonical" href="https://squareandangle.pranatigroup.in/detail" />

        <meta property="og:title" content="Pranati interior" />
        <meta property="og:description" content="Kolkata best Interior" />
        <meta property="og:image" content="/images/preview.png" />
        <meta property="og:url" content="https://squareandangle.pranatigroup.in/detail" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pranati interior" />
        <meta name="twitter:description" content="Kolkata best Interior" />
        <meta name="twitter:image" content="/images/preview.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Pranati Interior",
            "url": "https://squareandangle.pranatigroup.in/detail",
            "description": "Kolkata best Interior",
            "image": "https://squareandangle.pranatigroup.in/images/preview.png",
            "areaServed": "Kolkata",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Kolkata",
              "addressRegion": "West Bengal",
              "addressCountry": "IN"
            }
          })}
        </script>
      </Helmet>
    
    <div className='app'>

    <div className="breadcumb-area black-opacity bg-img-6">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="breadcumb-wrap">
                        <h2>Office Interior Decoration Ideas</h2>
                        <ul>
                            <li>You can find here your kolkata bedroom living room top sofa designs ideas manufacturers designers at affordable cost.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
  <div className="blog-area blog-details-area">
    <div className="container">
        <div className="row">
            {detail.map((item) => (
                <div className="col-lg-3 col-md-6 col-sm-6" key={item.id}>
                    <div className="blog-wrap">

                        <div
                            className="blog-img"
                            style={{
                                position: "relative"
                            }}
                        >
                            <img
                                src={uploadUrl(item.image)}
                                alt={item.title}
                                style={{
                                    width: "100%",
                                    height: "350px",
                                    objectFit: "cover",
                                    display: "block"
                                }}
                                onError={(e) => {
                                    e.currentTarget.style.display = "none";
                                }}
                            />

                            <button
                                onClick={() => handlelove(item.id)}
                                style={{
                                    position: "absolute",
                                    top: "15px",
                                    right: "15px",
                                    width: "45px",
                                    height: "45px",
                                    borderRadius: "50%",
                                    border: "none",
                                    background: "rgba(0,0,0,0.5)",
                                    color: selectedlove.includes(item.id)
                                        ? "red"
                                        : "#fff",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    zIndex: 9999,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                ♡
                            </button>
                        </div>

                        <div
    className="blog-content"
    style={{
        padding: "22px 20px",
        background: "#fff",
        minHeight: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    }}
>
    <div>
        <h4
            style={{
                margin: "0 0 12px",
                fontSize: "19px",
                lineHeight: "1.4",
                fontWeight: "600",
                color: "#222",
                letterSpacing: "0.2px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden"
            }}
        >
            {item.title}
        </h4>

        <p
            style={{
                margin: "0",
                fontSize: "14px",
                lineHeight: "1.7",
                color: "#777",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden"
            }}
        >
            {item.description}
        </p>
    </div>

    
</div>


                    </div>
                </div>
            ))}
        </div>
    </div>
</div>

   
    <div className="project-area">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="project-menu text-center mb-40">
                        <button className="active" data-filter="*">View All</button>
                        <button data-filter=".cat1">South Kolkata</button>
                        <button data-filter=".cat2">North Kolkata</button>
                        <button data-filter=".cat3">Howrah</button>
                        <button data-filter=".cat4">West Bengal</button>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
   
    
   
   
  
    <Footer />
             <Chat/>

      <WhatsAppButton />
    
    </div>
    
    
    
    </>
)
}
export default Detail;